import { apiFetch } from '../../../utils/api';

/**
 * Add a relationship mapping between user and organization
 * @param {string} targetId - The target ID (user or organization depending on mode)
 * @param {string} relViewMode - The view mode ('user' or 'organization')
 * @param {string} selectedId - The currently selected entity ID
 * @param {Function} setProcessingCell - Setter for processing cell state
 * @param {Function} setIsAssignDropdownOpen - Setter for dropdown open state
 * @param {Function} setSearchAssign - Setter for search assign state
 * @param {Function} fetchUsers - Function to refresh users
 * @param {Function} fetchOrganizations - Function to refresh organizations
 * @returns {Promise<void>}
 */
export const handleAddMapping = async (targetId, relViewMode, selectedId, setProcessingCell, setIsAssignDropdownOpen, setSearchAssign, fetchUsers, fetchOrganizations) => {
    const userId = relViewMode === 'user' ? selectedId : targetId;
    const organizationId = relViewMode === 'user' ? targetId : selectedId;
    const cellId = `${userId}-${organizationId}`;
    setProcessingCell(cellId);
    setIsAssignDropdownOpen(false);
    setSearchAssign('');
    try {
        const res = await apiFetch(`/api/auth/admin/users/${userId}/organizations/${organizationId}`, { method: 'POST' });
        if (res.ok) {
            await fetchUsers();
            await fetchOrganizations();
        } else {
            const errData = await res.json();
            alert(Array.isArray(errData) ? errData.map(e => e.description).join(' ') : 'Failed to assign relationship.');
        }
    } catch (err) {
        console.error('Error adding mapping', err);
    } finally {
        setProcessingCell(null);
    }
};

/**
 * Remove a relationship mapping between user and organization
 * @param {string} targetId - The target ID (user or organization depending on mode)
 * @param {string} relViewMode - The view mode ('user' or 'organization')
 * @param {string} selectedId - The currently selected entity ID
 * @param {Function} setProcessingCell - Setter for processing cell state
 * @param {Function} fetchUsers - Function to refresh users
 * @param {Function} fetchOrganizations - Function to refresh organizations
 * @returns {Promise<void>}
 */
export const handleRemoveMapping = async (targetId, relViewMode, selectedId, setProcessingCell, fetchUsers, fetchOrganizations) => {
    const userId = relViewMode === 'user' ? selectedId : targetId;
    const organizationId = relViewMode === 'user' ? targetId : selectedId;
    const cellId = `${userId}-${organizationId}`;
    setProcessingCell(cellId);
    try {
        const res = await apiFetch(`/api/auth/admin/users/${userId}/organizations/${organizationId}`, { method: 'DELETE' });
        if (res.ok) {
            await fetchUsers();
            await fetchOrganizations();
        } else {
            const errData = await res.json();
            alert(Array.isArray(errData) ? errData.map(e => e.description).join(' ') : 'Failed to remove relationship.');
        }
    } catch (err) {
        console.error('Error removing mapping', err);
    } finally {
        setProcessingCell(null);
    }
};
